/**
 * Display messages extracted from workflow definition metadata.
 */
export interface AgentDisplayMessages {
  welcomeMessage: string;
  errorMessage: string;
}

/**
 * Extract display messages from an agent's workflow definition metadata.
 * Only display messages (welcomeMessage, errorMessage) are in metadata.
 * All prompts (systemMessage etc.) are stored in workflow nodes, not here.
 */
export const getAgentDisplayMessages = (
  agent: {
    workflow?: {
      definition?: Record<string, unknown> | null;
    } | null;
  } | null | undefined
): AgentDisplayMessages => {
  const metadata = (agent?.workflow?.definition?.metadata as Record<string, unknown>) || {};

  return {
    welcomeMessage: (metadata.welcomeMessage as string) || '',
    errorMessage: (metadata.errorMessage as string) || ''
  };
};

/**
 * Get the welcome message for an agent from workflow definition metadata.
 */
export const getAgentWelcomeMessage = (
  agent: {
    workflow?: {
      definition?: Record<string, unknown> | null;
    } | null;
  } | null | undefined
): string => {
  return getAgentDisplayMessages(agent).welcomeMessage;
};
